import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div className='main'>
        <h2>About</h2>
        <h3>Tech Stack</h3>
        <h3>Team Bios</h3>
        <h3>Credits</h3>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/About.js